import getUserLinks from "data/actions/getUserLinks";
import { dispatchSliceWithCSRF } from "./hooks/dispatchSliceWithCSRF";

export default function WithLinks({ children }) {
  dispatchSliceWithCSRF(getUserLinks);
  return children;
}
